import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'

import AdminAccount from 'pages/Admin/Account'
import AdminTopic from 'pages/Admin/Topics'
import AdminUsage from 'pages/Admin/Usage'
import AdminIntegrationsRoutes from 'pages/Admin/Integrations/Routes'
import Billing from 'pages/Admin/Billing'
import Users from 'pages/Admin/Users'
import AdminSurveys from 'pages/Admin/Surveys'
import TestimonialsPage from './Testimonials'
import { Email } from './Email'
import Authentication from 'pages/Admin/Authentication'
import AdminRole from 'pages/Admin/Roles'
import AdminApiKey from 'pages/Admin/ApiKey'
import AdminBrands from './Brands'
import TestimonialsPageV2Container from './TestimonialsV2/container'
import PermissionRoute from 'domains/routes/PermissionRoute'
import constants from 'config/constants'

// settings Route already has HOC that check for view_settings permissions
// If user has view setting permission then they're allowed to access all of these
const Routes = () => (
  <Switch>
    <Redirect from="/:workspaceToken/settings/" exact to="/:workspaceToken/settings/workspace/" />
    <Route path="/:workspaceToken/settings/workspace/" component={AdminAccount} />
    <Route path="/:workspaceToken/settings/usage/" component={AdminUsage} />
    <Route path="/:workspaceToken/settings/brands/" component={AdminBrands} />
    <Route path="/:workspaceToken/settings/surveys/" component={AdminSurveys} />
    <Route path="/:workspaceToken/settings/topics/" component={AdminTopic} />
    <Route path="/:workspaceToken/settings/roles/" component={AdminRole} />
    <Route path="/:workspaceToken/settings/integrations/" component={AdminIntegrationsRoutes} />
    <Route
      path="/:workspaceToken/settings/feedback-widgets/"
      component={TestimonialsPageV2Container}
    />
    <Route path="/:workspaceToken/settings/testimonials/" component={TestimonialsPage} />
    <Route path="/:workspaceToken/settings/users/" component={Users} />
    <Route path="/:workspaceToken/settings/email/" component={Email} />
    <PermissionRoute
      permission={constants.permissions.viewBillingPage}
      path="/:workspaceToken/settings/billing/"
      component={Billing}
    />
    <PermissionRoute
      permission={constants.permissions.manageAuthenticationSecurity}
      path="/:workspaceToken/settings/authentication/"
      component={Authentication}
    />
    <PermissionRoute
      permission={constants.permissions.accessApiKey}
      path="/:workspaceToken/settings/api-keys/"
      component={AdminApiKey}
    />
    <Route render={() => <Redirect to="/404/" />} />
  </Switch>
)

export default Routes



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Routes.js